import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";
import { format } from 'date-fns';
import { getInstallations } from "network/ApiAxios";

const AccountInformation = (props) => {
    const subscription = props.subscription
    const formDisabled = props.formDisabled
    const [license, setLicense] = useState()

    useEffect(() => {

        const runAsync = async () => {
            let params = { filter: { subscription: subscription._id } }

            const response = await getInstallations(params);
            const { data } = response;

            if (data.success) {
                setLicense(data.installation?.license._id)
            }

        }
        runAsync();
    }, [])

    let formatDate = (date) => {

        let formDate = date ? format(date, "yyyy-MM-dd") : ''
        return formDate
    }

    let computeExpirationDate = (date, periodicity) => {

        if(!(date && periodicity)) return ''

        let startDate = new Date(date);
        let endDate = new Date(startDate.setMonth(startDate.getMonth() + periodicity));
        
        return formatDate(endDate.toDateString())
    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">Account Information</h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-creation"
                            >
                                Creation Date
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-creation"
                                defaultValue={formatDate(subscription.date)}
                                type="date"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-licenses"
                            >
                                Expiration Date
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-licenses"
                                defaultValue={computeExpirationDate(subscription?.date, subscription?.plan?.periodicity)}
                                type="date"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default AccountInformation